import { all, takeLatest } from 'redux-saga/effects';
import { types as solucionesTypes } from '../reducers/soluciones';
import { types as fichasTypes } from '../reducers/fichas';
import { types as commonTypes } from '../reducers/common';
import {
  setSolucion,
} from './soluciones';
import {
  setFicha,
} from './fichas';
import { getBusinessProps } from './common';

export default function* rootSaga() {
  yield all([
    takeLatest(solucionesTypes.GET_SOLUCIONES_BEGINS, setSolucion),
    takeLatest(fichasTypes.GET_FICHAS_BEGINS, setFicha),
    takeLatest(commonTypes.GET_BUSINESS_CONSTANTS, getBusinessProps),
  ]);
}
